export default "__VITE_ASSET__CXAVppe0__"